<template>

    <div class="container-center">

        <el-card class="box-card">

            <div slot="header" class="clearfix contract-data-top with-icon">
                <img
                    src="data:image/png;base64,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">
                <p><span class="title">{{ detailData.materialExcessName || '统购（三材）材料超量审批单发起' }}</span></p>
                <p class="status">
                    <span :title="detailData.approveStatus" v-bind:class="['state-shet'+ detailData.approveStatus]">
                        {{ baseStatus[detailData.approveStatus] }}
                        {{ detailData.nodeName && (`（当前审批节点：${detailData.nodeName}）`) }}
                    </span>
                </p>
                <br>所属合同：{{ decodeURIComponent($route.params.name) }} &nbsp;&nbsp;&nbsp;&nbsp; <span v-if="pageType!=0">发起时间：{{ detailData.createDate }}</span>
            </div>


            <!-- 材料列表 -->
            <label v-if="pageType!=0" class="fade-title">统购（三材）材料超量审批单编号：{{ detailData.materialExcessId }}</label>

            <div v-if="pageType==0 || detailData.approveStatus==4 || editMode" style="padding-top:20px;">
                <el-form label-width="200px" ref="form" :model="form" :rules="rules" size="mini">
                    <el-row>
                        <el-col :span="12" :offset="6">
                            <el-form-item label="类型：" prop="type">
                                <el-radio-group v-model="form.type" @change="radioChange">
                                    <el-radio label="sc">三材</el-radio>
                                    <el-radio label="tg">统购</el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item v-if="form.type=='sc'" label="材料名称：" prop="materialName">
                                <el-radio-group v-model="form.materialName" @change="radioChange">
                                    <el-radio label="钢筋">钢筋</el-radio>
                                    <el-radio label="商品砼">商品砼</el-radio>
                                    <el-radio label="商品砂浆">商品砂浆</el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item v-if="form.type=='tg'" label="材料名称：" prop="materialName">
                                <el-input v-model="form.materialName" clearable></el-input>
                            </el-form-item>
                            <el-form-item label="原预算用量：" prop="budgetDosage">
                                <el-col :span="16">
                                    <el-input v-model.number="form.budgetDosage" clearable></el-input>
                                </el-col>
                                <el-col :span="7" :offset="1">
                                    <el-select v-if="form.type=='tg'" v-model="form.budgetDosageUnitId" placeholder="单位">
                                        <el-option v-for="o in allUnit" :label="o.fnameL2" :value="o.fid"
                                                   :key="o.fid"></el-option>
                                    </el-select>
                                    <el-select v-if="form.type=='sc'" v-model="form.budgetDosageUnitId" placeholder="单位">
                                        <el-option v-for="o in curUnit" :label="o.fnameL2" :value="o.fid"
                                                   :key="o.fid"></el-option>
                                    </el-select>
                                </el-col>
                            </el-form-item>
                            <el-form-item label="已使用量：" prop="alreadyUse">
                                <el-col :span="16">
                                    <el-input v-model.number="form.alreadyUse" clearable></el-input>
                                </el-col>
                                <el-col :span="7" :offset="1">
                                    <el-select v-if="form.type=='tg'" v-model="form.alreadyUseUnitId" placeholder="单位">
                                        <el-option v-for="o in allUnit" :label="o.fnameL2" :value="o.fid"
                                                   :key="o.fid"></el-option>
                                    </el-select>
                                    <el-select  v-if="form.type=='sc'"v-model="form.alreadyUseUnitId" placeholder="单位">
                                        <el-option v-for="o in allUnit" :label="o.fnameL2" :value="o.fid"
                                                   :key="o.fid"></el-option>
                                    </el-select>
                                </el-col>
                            </el-form-item>
                            <el-form-item label="需增加用量：" prop="addDosage">
                                <el-col :span="16">
                                    <el-input v-model.number="form.addDosage" clearable></el-input>
                                </el-col>
                                <el-col :span="7" :offset="1">
                                    <el-select v-if="form.type=='tg'" v-model="form.addDosageUnitId" placeholder="单位">
                                        <el-option v-for="o in allUnit" :label="o.fnameL2" :value="o.fid"
                                                   :key="o.fid"></el-option>
                                    </el-select>
                                    <el-select v-if="form.type=='sc'" v-model="form.addDosageUnitId" placeholder="单位">
                                        <el-option v-for="o in allUnit" :label="o.fnameL2" :value="o.fid"
                                                   :key="o.fid"></el-option>
                                    </el-select>
                                </el-col>
                            </el-form-item>
                            <el-form-item label="申请原因：" prop="applyReason">
                                <el-input v-model="form.applyReason" type="textarea" clearable></el-input>
                            </el-form-item>
                            <el-form-item label="附件：" prop="">
                                <el-upload
                                    class="upload-demo"
                                    multiple
                                    ref="upload"
                                    :limit="20"
                                    :action="uploadApi"
                                    :file-list="form.baseFileList"
                                    :on-success="handleAdd" :on-error="uploadError"
                                    :before-upload="beforeUpload"
                                    :on-remove="handleRemove"
                                >
                                    <el-button size="small" type="primary">上 传</el-button>
                                    <div slot="tip" class="el-upload__tip">上传附件大小请不要超过100M。<br>
                                        <span class="redTip">注意：附件上传出现绿色打勾标志，才表示上传成功。</span></div>
                                </el-upload>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>

            <!-- 详情 -->
            <div v-if="pageType != 0 &&  detailData.approveStatus!=4 && !editMode" class="detail-box">
                <el-row>
                    <el-col :span="5" class="text-right">类型：</el-col>
                    <el-col :span="19">{{ form.type || '无' }}</el-col>
                </el-row>
                <el-row>
                    <el-col :span="5" class="text-right">材料名称：</el-col>
                    <el-col :span="19">{{ form.materialName || '无' }}</el-col>
                </el-row>
                <el-row>
                    <el-col :span="5" class="text-right">原预算用量：</el-col>
                    <el-col :span="19">{{ form.budgetDosage || '无' }} {{ allUnits['no'+ form.budgetDosageUnitId] }}
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="5" class="text-right">已使用量：</el-col>
                    <el-col :span="19">{{ form.alreadyUse || '无' }} {{ allUnits['no'+ form.alreadyUseUnitId] }}</el-col>
                </el-row>
                <el-row>
                    <el-col :span="5" class="text-right">需增加用量：</el-col>
                    <el-col :span="19">{{ form.addDosage || '无' }} {{ allUnits['no'+ form.addDosageUnitId] }}</el-col>
                </el-row>
                <el-row>
                    <el-col :span="5" class="text-right">申请原因：</el-col>
                    <el-col :span="19">{{ form.applyReason || '无' }}</el-col>
                </el-row>
                <el-row>
                    <el-col :span="5" class="text-right">附件：</el-col>
                    <el-col :span="19">
                        <div v-if="!form.baseFileList || form.baseFileList && form.baseFileList.length==0"
                             class="no-data-tip"></div>
                        <ul v-else>
                            <li v-for="li in form.baseFileList" :key="li.id"><a :href="downloadApi +'?fileId='+ li.id"
                                                                                target="_blank">{{ li.fileOldName }}</a>
                            </li>
                        </ul>
                    </el-col>
                </el-row>
            </div>


            <el-row>
                <el-col :span="12" :offset="6">
                    <div class="text-center" style="padding:30px 0;">
                        <el-button @click="$router.push($root.navs[1].path)" type="" size="medium" icon="el-icon-back">
                            返回合同台账
                        </el-button>
                        <!-- <el-button v-if="!editMode && (detailData.approveStatus==0 || detailData.approveStatus==1)"
                                   @click="editMode=true" type="primary" size="medium">修 改
                        </el-button>
                        <el-button v-if="editMode" @click="getDetailData();editMode=false;" type="primary"
                                   size="medium">退出修改
                        </el-button> -->
                        <el-button v-if="pageType==0" @click="submit" type="primary" size="medium">提交申请</el-button>
                    </div>
                </el-col>
            </el-row>


            <!-- 分隔线 -->
            <div v-if="pageType!=0" class="fade-line"></div>


            <!-- 审批记录 -->
            <div v-if="pageType!=0">
                <label class="fade-title">审批记录</label>

                <el-table :data="detailData.approveList||[]" size="mini" border stripe>
                    <el-table-column align="center" width="50" type="index" label="序号"></el-table-column>
                    <el-table-column align="center" width="160" label="发起时间" prop="createDate"></el-table-column>
                    <el-table-column align="center" width="160" label="审批结果" prop="approveStatus">
                        <template slot-scope="scope">
                            <span v-bind:class="'state-shet'+scope.row.approveStatus" :title="scope.row.approveStatus">
                                {{ baseStatus[scope.row.approveStatus] }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="审批意见" prop="approveRemark"></el-table-column>
                    <el-table-column align="center" width="160" label="审批时间" prop="approveDate"></el-table-column>
                </el-table>
            </div>
        </el-card>


    </div><!-- container-center -->

</template>

<script type="text/babel">
    import banner from '@/assets/imgs/banner_inviteMng.png'
    //import ElBadge from 'element-ui/packages/badge/src/main'
    import util from '@/util'
    //import ElOption from "element-ui/packages/select/src/option";
    //import ElInput from "element-ui/packages/input/src/input";

    export default {
//    components: {
//        ElInput,
//        ElOption,
//        ElBadge},
        name: 'contract-detail',
        data() {
            return {

                uploadApi: `${util.baseUrl}rest/file/upload`,
                downloadApi: `${util.baseUrl}rest/file/down`,

                allUnit: [],
                curUnit: [],
                allUnits: {},

                baseStatus: ['草稿', '待审批', '审批中', '审批通过', '审批不通过'],

                // 编辑模式
                editMode: false,

                // 表单验证
                rules: {
                    类型: [
                        {required: true, message: '必选'}
                    ],
                    materialName: [
                        {required: true, message: '必填'}
                    ],
                    budgetDosage: [
                        {required: true, message: '必填'},
                        {type: 'number', message: '数字'}
                    ],
                    alreadyUse: [
                        {required: true, message: '必填'},
                        {type: 'number', message: '数字'}
                    ],
                    addDosage: [
                        {required: true, message: '必填'},
                        {type: 'number', message: '数字'}
                    ],
                    applyReason: [
                        {required: true, message: '必填'},
                    ]
                },

                // 页面类型 0: 发起,带billId;  1: 查看,带msgId
                pageType: this.$route.params.type,


                // 详情数据
                detailData: {
                    dhsConPricingDetailList: []
                },

                // 表单
                form: {
                    type: 'sc',
                    materialName: '钢筋',
                    budgetDosage: '',
                    budgetDosageUnitId: '',
                    alreadyUse: '',
                    alreadyUseUnitId: '',
                    addDosage: '',
                    addDosageUnitId: '',
                    applyReason: '',
                    baseFileList: []
                },
            }
        },
        methods: {

            // 上传文件格式验证
            beforeUpload(file) {

                if (file.size / 1024 / 1024 > 100) {
                    this.$alert('上传附件大小请不要超过100M', '文件过大！', {type: 'error'})
                    return false
                }

                if (!util.allowUpload(file.name)) {
                    this.$alert(`支持的文件类型：${util.acceptFileTypes.join(' | ')}`, '文件类型不支持，已取消上传！', {type: 'error'})
                    return false
                }
                return true
            },

            uploadError() {
                this.$message({message: '上传出错，请稍后再试。', type: 'error'});
            },

            getAllUnit() {
                const loading = this.$loading({lock: true, background: 'rgba(255,255,255,0.5)'});
                this.$http.post('rest/api/contract/getAllUnit', {}).then((res) => {

                    loading.close()

                    if (res.data.result) {
                        this.allUnit = res.data.value
                        this.allUnit.forEach((data, index) => {
                            this.allUnits['no' + data.fid] = data.fnameL2;
                        })

                        // if (this.allUnit[0]) {
                        //     this.form.budgetDosageUnitId = this.allUnit[0].fid
                        //     this.form.alreadyUseUnitId = this.allUnit[0].fid
                        //     this.form.addDosageUnitId = this.allUnit[0].fid
                        // }
                        this.getCurUnit();

                    } else {
                        this.$message({message: 'Error: 单位获取失败', type: 'error'})
                        return
                    }
                    this.getDetailData()
                })
            },

            getCurUnit(){
                this.curUnit=[];
                this.allUnit.forEach((data, index) => {
                    if(this.form.type=='sc' && (this.form.materialName=='钢筋'||this.form.materialName=='商品砂浆')){
                        if(data.fnameL2=='t'){
                            this.curUnit.push(data)
                        }
                    }
                    if(this.form.type=='sc' && this.form.materialName=='商品砼'){
                        if(data.fnameL2=='m3'){
                            this.curUnit.push(data)
                        }
                    }
                })
                if (this.curUnit[0]) {
                    this.form.budgetDosageUnitId = this.curUnit[0].fid;
                    this.form.alreadyUseUnitId = this.curUnit[0].fid
                    this.form.addDosageUnitId = this.curUnit[0].fid
                }
            },

            radioChange(){
                if(this.form.type=='sc'){
                    if(this.form.materialName == ''){
                        this.form.materialName = '钢筋';
                    }
                    this.getCurUnit();
                }
                if(this.form.type=='tg'){
                    this.form.materialName = '';
                }
            },

            // 提交
            submit() {
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        const loading = this.$loading({background: 'rgba(255,255,255,0.5)'});

                        this.form.baseFileList =  __getBaseFiles__(null, this.$refs.upload.uploadFiles)

                        if (this.pageType == 0) {  // 发起
                            this.$http.post('rest/api/contract/createMaterialExcess',
                                Object.assign(
                                    {
                                        contractBillId: this.$route.params.id
                                    },
                                    this.form
                                )
                            ).then((res) => {

                                // loading.close()

                                if (res.data.result) {
                                    this.$message({message: '提交成功', type: 'success'})

                                    // 提交后跳转
                                    this.$router.push('/ContractDetail08/1/' + res.data.value.id + '/' + encodeURIComponent(this.$route.params.name))
                                    setTimeout(function () {
                                        location.reload()
                                    }, 1000)

                                } else {
                                    this.$message({message: 'Error: 提交失败', type: 'error'})
                                }
                            })
                        } else {  // 不通过二次提交
                            // this.$http.post('rest/api/contract/updateMaterialExcess',
                            //     Object.assign(
                            //         {
                            //             id: this.$route.params.id,
                            //             contractBillId: this.detailData.contractBillId
                            //         },
                            //         this.form
                            //     )
                            // ).then((res) => {

                            //     loading.close()

                            //     if (res.data.result) {
                            //         this.$message({message: '修改成功', type: 'success'})

                            //         this.getDetailData()
                            //         this.editMode = false
                            //     } else {
                            //         this.$message({message: 'Error: 修改失败', type: 'error'})
                            //     }
                            // })
                        }

                    } else {
                        this.$message({message: '材料表单填写有误', type: 'error'})
                        return false;
                    }

                });

            },

            // 获取详情
            getDetailData() {
                const loading = this.$loading({background: 'rgba(255,255,255,0.5)'});
                this.$http.post('rest/api/contract/getMaterialExcessInfo', {
                    msgId: this.$route.params.id
                }).then((res) => {
                    loading.close();
                    if (res.data.result) {
                        if (res.data.value) {
                            this.detailData = res.data.value;
                            this.form = res.data.value;

                            this.form.baseFileList.forEach(function (data) {
                                data.name = data.fileOldName
                            })

                            this.$root.navs = [{
                                name: '合同业务列表',
                                path: '/contractList'
                            }, {
                                name: decodeURIComponent(this.$route.params.name),
                                path: '/contractSheet/' + encodeURIComponent(this.detailData.contractBillId)
                            }, {name: '详情'}]
                        }

                    } else {
                        this.$message({message: 'Error: 获取详情', type: 'error'})
                    }
                })
            },

            handleRemove: function (file, fileList) {
                // this.form.baseFileList = this.form.baseFileList.filter(function (f) {
                //     return f.uid !== file.uid
                // });
            },
            handleAdd: function (response, file, fileList) {
                // if(file.status=='success'){
                // this.form.baseFileList = __getBaseFiles__(file, fileList)
                // }
            },


        },
        created() {
            this.$root.headImage.src = banner
            this.$root.activeIndex = 'home'
            this.$root.isPublic = false
            this.$root.navs = []

            this.getAllUnit()
        },
        mounted() {

            // dev test
            window.ji = this;

            // 0: 发起 带billId;  1: 查看 带msgId
            if (this.pageType == 0) {
                this.$root.navs = [{
                    name: '合同业务列表',
                    path: '/contractList'
                }, {
                    name: decodeURIComponent(this.$route.params.name),
                    path: '/contractSheet/' + encodeURIComponent(this.$route.params.id)
                }, {name: '发起'}]
            } else {
                this.getDetailData()
            }

            util.toTop()

        }
    }

    function __getBaseFiles__(file, fileList) {
        let fs = [];
        fileList.forEach(function (item) {
            console.log(item)
            if (item.response) {
                let f = item.response.basefiles[0];
                item.bizTableName = f.biztablename;
                item.bizTablePkName = f.biztablepkname;
                item.bizTablePkValue = f.biztablepkvalue;
                item.fid = f.fid;
                item.fileCatagoryId = f.filecatagoryid;
                item.fileDesc = f.filedesc;
                item.fileOldName = f.fileoldname;
                item.name = f.fileoldname;
                item.fileName = f.filename;
                item.filePath = f.filepath;
                item.fileSize = f.filesize;
                item.fileType = f.filetype;
                item.sort = f.sort;
            }
            fs.push(item);
        });
        console.log(fs);
        return fs
    }
</script>

<style scoped lang="postcss">
    @import '../../../assets/common.css';


    a {
        color: var(--cMain);
        cursor: pointer;
    }

    ul {
        padding: 0;
        margin: 0;
    }

    ul li {
        list-style: none;
    }

    .box-card {
        margin: 30px 0;
    }


    .fade-title {
        display: inline-block;
        margin-bottom: 20px;
        color: var(--cTxt2);
        font-size: 15px;
        font-weight: bold;
        line-height: 28px;
    }

    .fade-line {
        border-top: 1px dashed #ddd;
        margin: 40px 0;
    }


    .detail-box {
        padding: 20px 120px;
    }

    .detail-box .el-row {
        line-height: 48px;
    }

    .detail-box .text-right {
        color: var(--cTxt3);
    }


</style>



// WEBPACK FOOTER //
// src/pages/dsp/contract/vDetail08.vue